import axios from 'axios';

export default {
  template: "#vue-gift-cards",
  delimiters: ['${', '}'],
  props: [],
  data() {
    return {
      card_number: "",
      check_error: null,
      balance: null,
      tx_history: null,
      submitting: false
    }
  },
  methods: {
    submit(e) {
      if (this.card_number.length !== 21) {
        this.check_error = "not_21"
        return
      }
      if (parseInt(this.card_number).toString().length !== 21) {
        this.check_error = "not_numeric"
        return
      }
      this.submitting = true
      this.balance = null
      this.tx_history = null
      this.check_error = null

      axios.get('/apps/api/gift-cards/balance',
          {params: {card: this.card_number}}).then(
          resp => {
            this.submitting = false
            this.balance = resp.data.balance
            this.tx_history = resp.data.history
            this.check_error = null
          }
      ).catch(e => {
        this.submitting = false
        if (e.response) {
          if (e.response.data && e.response.data.error) {
            this.check_error = e.response.data.error
            return
          }
        }
        this.check_error = "unspecific_error"
      })
    }
  }
}